import React from 'react'
import AdnCard from '../common/adnCard/AdnCard'
import AdnPageTitle from '../common/adnPageTitle/AdnPageTitle'
import AdnTable from '../common/adnTable/AdnTable'
import { Col, Modal, Row, Space, Form } from 'antd';
import AdnAddButton from '../common/adnAddButton/AdnAddButton';
import adnYesNoModal from '../common/adnYesNoModal/AdnYesNoModal';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../AppRoutes';

function ProjectListForm({
  loading,
  projectData,
  event,
  setEvent,
  visible,
  setVisible,
  submitProject,
  setProjectHandler,
  addProject,
  deleteProjectData }) {

  const navigate = useNavigate();
  
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: '30%',
      editable: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Type',
      dataIndex: 'typeName',
      width: '25%',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      width: '30%',
    },
    {
      title: 'Duration (Days)',
      dataIndex: 'duration',
      width: '35%',
    },
    {
      title: "Actions",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: "black" }}
            onClick={() => {
              setVisible(true);
              setEvent("edit");
              setProjectHandler(record);
              form.setFieldsValue(record);
              navigate(AppRoutes.projectId(record.id));
            }}
          />

          <DeleteOutlined
            style={{ color: "red" }}
            onClick={() => {

              adnYesNoModal(() => deleteProjectData(record.id));
            }}
          />
        </Space>
      ),
      width: "10%",
    },
  ];
  const [form] = Form.useForm();
  return (
    <>
      <AdnPageTitle title={"Projects"} />
      <AdnCard loading={loading}>

        <AdnAddButton handleClick={addProject} />

        <Row>
          <Col span={24}>
            <AdnTable data={projectData} columns={columns}/>
          </Col>
        </Row>

      </AdnCard>
    </>
  )
}

export default ProjectListForm